import axios from 'axios'
import React from 'react'
import { baseUrl } from '../assets/Animations'
import AddNote from './AddNote/AddNote'
import './create-timesheet.css'
import CreateTimesheetAreYouSure from './CreateTimesheetAreYouSure/CreateTimesheetAreYouSure'
import FamilyCard from './FamilyCard/FamilyCard'

const CreateTimesheet = (props) => {
    const [families, setFamilies] = React.useState([])
    const [finalWarning, setFinalWarning] = React.useState(false)
    const [note, setNote] = React.useState('')
    const [notesOpen, setNotesOpen] = React.useState(false)
    const [estimatedPay, setEstimatedPay] = React.useState(0)
    const [listOfFamiliesForTeachers, setListOfFamiliesForTeachers] = React.useState([])
    const [incomplete, setIncomplete] = React.useState(false)
    const [monthNumber, setMonthNumber] = React.useState(0)
    const [cancellationWarning, setCancellationWarning] = React.useState(false)


    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }



    let d = new Date()
    let theYear = d.getFullYear()
    let theMonthNumber = d.getMonth()

    React.useEffect(() => {
        const getTeachersFamilies = async () => {
            let fixedName = encodeURIComponent(props.userData.Name.trim())
            //let REPLACEWITHFIXEDNAME = 'Andi%20Bonato'
            let res = await axios.get(`${baseUrl}/teachersfamilies/${props.userData.TeacherID}`, myHeader)
            setListOfFamiliesForTeachers(res.data)
        }
        getTeachersFamilies()
        calculateEstimatedPay()
        createDateSettings()
    },[])

    React.useEffect(() => {
        if(families.length > 0) {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = "rgba(0, 128, 0, 0.747)"
            }
        } else {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = 'rgba(128, 128, 128, 0.336)'
            }
        }
        // if(props.families) {
        //     setFamilies(props.families)
        // }
        calculateEstimatedPay()

        //CHECK IF EVERYTHING IS FILLED OUT
        for(let i = 0; i < families.length; i++) {
            let theFamily = families[i]
            for(let i = 0; i < theFamily.lessons.length; i++) {
                if(theFamily.lessons[i].studentName === '' || theFamily.lessons[i].lessonLength === 0 || theFamily.lessons[i].date === "") {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }    
            }
            for(let i = 0; i < theFamily.cancellations.length; i++) {
                if(theFamily.cancellations[i].cancellor === 'teacher') {
                    setCancellationWarning(true)
                } else {
                    setCancellationWarning(false)
                }
                if(theFamily.cancellations[i].student === '' || theFamily.cancellations[i].cancellor === '0' || (theFamily.cancellations[i].lessonLength === 0 && theFamily.cancellations[i].cancellor === "student less than 24hrs") || theFamily.cancellations[i].date === "") {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }
            }
            for( let i = 0; i < theFamily.extras.length; i++) {
                if(theFamily.extras[i].description === '' || theFamily.extras[i].amount === 0) {
                    setIncomplete(true)
                    return
                } else {
                    setIncomplete(false)
                }
            }
        }
    }, [families])

    const createDateSettings = () => {
        let d = new Date()
        let month = d.getMonth()
        let day = d.getDate()
        let theYear = d.getFullYear()
        let adjustedMonth;
        if(day < 15) {
            if(month !== 0) {
                adjustedMonth = month
            } else if (month === 0) {
                adjustedMonth = 12
            } else {
                adjustedMonth = month + 1
            }
        } else {
            adjustedMonth = month  + 1
        }
        setMonthNumber(adjustedMonth)
    }

    const calculateEstimatedPay = () => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < families.length; i++) {
            let fam = families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        setEstimatedPay(((minutesTaught/60) * Number(props.rate)) + allExtras)
    }

    //ADD FAMILY
    const addFamily = () => {
        let newFamily = {
            id: '',
            familyName: '',
            lessons: [],
            cancellations: [],
            familyWaveId: '',
            listOfFamilyStudents: [],
            email: '',
            school: '',
            extras: [],
            familyNameEntered: false
        }
        setFamilies(prev => [...prev, newFamily])
    }
    //CHANGE FAMILY NAME
    const changeFamilyName = (index, familyObj) => {
        let newArr = [...families]
        if(familyObj.familyName){
            newArr[index].familyName = familyObj.familyName
        }
        if(familyObj.students){
            newArr[index].listOfFamilyStudents = familyObj.students
        }
        if(familyObj.waveCustomerId){
            newArr[index].familyWaveId = familyObj.waveCustomerId
        }
        if(familyObj.primaryEmail){
            newArr[index].email = familyObj.primaryEmail
        }
        if(familyObj.school){
            newArr[index].school = familyObj.school
        }
        if(familyObj.familyId){
            newArr[index].id = familyObj.familyId
        }

        setFamilies(newArr)

    }
    const autoOpenFamilyCardWhenNameIsSelected = (index, value) => {
        if(value === '*') {
            changeFamilyName(index, value)
        } else {
            changeFamilyName(index, value)
            submitLastName(index)
        }
    }
    const submitLastName = (index) => {
        let newArr = [...families]
        newArr[index].familyNameEntered = true
        setFamilies(newArr)
    }
    //REMOVE FAMILY
    const removeFamily = (id) => {
        setFamilies(families.filter(fam => fam.id !== id))
    }
    //ADD LESSON
    const addLesson = index => {
        let newLesson = {
            id: Math.random().toString(16).slice(2),
            studentName: '',
            lessonLength: 0,
            studentRate: 0,
            studentAllRates: {15: 0, 30: 0, 45: 0, 60: 0},
            date: '',
            enterNameManually: false
        }
        let newArr = [...families]
        newArr[index].lessons.push(newLesson)
        setFamilies(newArr)
    }
    const editLesson = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].lessons[index2][key] = value
        if(key === 'studentName') {
            for(let i = 0; i < listOfFamiliesForTeachers.length; i++) {
                if(listOfFamiliesForTeachers[i].familyName === newArr[index1].familyName) {
                    let theFamiliesStudents = listOfFamiliesForTeachers[i].students
                    for(let i = 0; i < theFamiliesStudents.length; i++) {
                        if(theFamiliesStudents[i].studentName === value) {
                            newArr[index1].lessons[index2].studentRate = theFamiliesStudents[i].lessonRate
                            newArr[index1].lessons[index2].studentAllRates = theFamiliesStudents[i].allRates
                        }
                    }
                }
            }
        }
        if(value === '*') {
            newArr[index1].lessons[index2][key] = ''
            newArr[index1].lessons[index2].enterNameManually = true
        }
        setFamilies(newArr)
    }
    const editCancellation = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].cancellations[index2][key] = value
        if(value === '*') {
            newArr[index1].cancellations[index2][key] = ''
            newArr[index1].cancellations[index2].enterNameManually = true
        }
        setFamilies(newArr)
    }
    //REMOVE LESSON
    const removeLesson = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].lessons = newArr[index].lessons.filter(less => less.id !== lessonId)
        setFamilies(newArr)
    }

    //ADD CANCELLATION
    const addCancellation = index => {
        let newLesson = {
            id: Math.random().toString(16).slice(2),
            student: '',
            cancellor: '0',
            lessonLength: 0,
            date: '',
            enterNameManually: false
        }
        let newArr = [...families]
        newArr[index].cancellations.push(newLesson)
        setFamilies(newArr)
    }
    //REMOVE CANCELLATION
    const removeCancellation = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].cancellations = newArr[index].cancellations.filter(less => less.id !== lessonId)
        setFamilies(newArr)
    }
    const addExtra = (index) => {
        let newExtra = {
            id: Math.random().toString(16).slice(2),
            description: '',
            amount: 0
        }
        let newArr = [...families]
        newArr[index].extras.push(newExtra)
        setFamilies(newArr)
    }
    const editExtra = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].extras[index2][key] = value
        setFamilies(newArr)
    }
    const removeExtra = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].extras = newArr[index].extras.filter(ex => ex.id !== lessonId)
        setFamilies(newArr)
    }
    const tryToSubmitTimesheet = () => {
            setFinalWarning(true)
    }

    const submitTimesheet = async () => {
        let teachersTime = {
            timesheetId: Math.random().toString(16).slice(2),
            teacherId: props.userData.TeacherID,
            teacherName: props.userData.Name,
            families: families,
            status: 'submitted',
            note: note,
            submitDate: new Date(),
            monthYear: `${props.month}/${props.myYear}`,
            teacherRate: props.rate,
            school: props.userData.School,
            email: props.userData.Email,
            monthNumber: monthNumber,
            year: props.myYear

        }
        setFinalWarning(false)
        axios.post(`${baseUrl}/teachertimesheet`, {
            teacherTimesheet: teachersTime
        }, myHeader)
        .then((res) => {
            props.pushNewTimesheetToTimesheets(res.data)
            props.setOpenUpTheTimesheet(false)
            props.setThankYouForSubmitting(true)
            props.setTryingToSubmitTimesheet(false)
        })
        .catch((err) => {
            console.log(err)
            console.log('oops there was an error')
        })
    }

    const cancelOutOfTimesheetProcess = () => {
        props.setTryingToSubmitTimesheet(false)
        props.setOpenUpTheTimesheet(false)
    }

    return(
        <div className="create-timesheet-wrapper">
            <div className="create-timesheet">
                {finalWarning && <CreateTimesheetAreYouSure submitTimesheet={submitTimesheet} setFinalWarning={setFinalWarning} />}
                {notesOpen && <AddNote setNotesOpen={setNotesOpen} note={note} setNote={setNote} />}
                <div className="another-x-wrapper">
                    <h3 className="close-create-timesheet-x" onClick={() => cancelOutOfTimesheetProcess()}>X</h3>
                </div>
                <h1>Create Timesheet</h1>
                <h2>{props.month} {props.myYear}</h2>
                <div className="family-card-section">
                    {families.map((fam, index) => 
                        <FamilyCard
                            key={fam.id}
                            index={index}
                            fam={fam}
                            reviewing={props.reviewing}
                            timesheet={props.timesheet}
                            addWaveIdToFamilyInformation={props.addWaveIdToFamilyInformation}
                            listOfFamilies={props.listOfFamilies}
                            listOfFamiliesForTeachers={listOfFamiliesForTeachers}
                            month={monthNumber}
                            changeFamilyName={changeFamilyName}
                            autoOpenFamilyCardWhenNameIsSelected={autoOpenFamilyCardWhenNameIsSelected}
                            removeFamily={removeFamily}
                            addLesson={addLesson}
                            removeLesson={removeLesson}
                            addCancellation={addCancellation}
                            removeCancellation={removeCancellation}
                            editLesson={editLesson}
                            submitLastName={submitLastName}
                            editCancellation={editCancellation}
                            addExtra={addExtra}
                            editExtra={editExtra}
                            removeExtra={removeExtra}
                        />
                    )}
                </div>
                <div className="add-family" onClick={() => addFamily()}>+ Add Family</div>
                <div className="create-timesheet-bottom-sections">
                    {cancellationWarning && note === '' && <div className='create-timesheet__note-warning'>Explain cancellation w/ note</div>}
                    <div className="create-timesheet__add-note" style={cancellationWarning && note === '' ? {animation: "grow 1.4s linear infinite"} : {color: "#000"}} onClick={() => setNotesOpen(true)}>+ Note</div>
                    {note !== '' && <div className="create-timesheet-pencil"></div>}
                    <h3 className="create-timesheet__estimated-pay">Estimate Pay: ${estimatedPay}</h3>
                    <div>
                        <div className="create-timesheet__submit-timesheet" onClick={() => tryToSubmitTimesheet()} id="create-timesheet__submit-btn">Submit Timesheet</div>
                        {incomplete && <p style={{color: "red"}}>Please Fill Out Everything</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CreateTimesheet;